// Utility functions for the miyogur app

/**
 * Generate a UUID for cart items
 * @returns {string} UUID string
 */
export const generateUUID = () => {
  return crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2);
};

/**
 * Format the WhatsApp message for orders
 * @param {Array} cartItems - Array of cart items
 * @param {Object} catalog - Catalog configuration
 * @param {Object} whatsappConfig - WhatsApp configuration
 * @returns {string} Formatted WhatsApp message
 */
export const formatWhatsAppMessage = (cartItems, catalog, whatsappConfig) => {
  if (cartItems.length === 0) return "";
  
  const header = `Hola ${whatsappConfig.businessName}\n\n`;
  
  const itemsText = cartItems.map((item, index) => {
    const sizeMeta = catalog.sizes.find((s) => s.id === item.size);
    const flavorMeta = catalog.flavors.find((f) => f.id === item.flavor);
    const flavorLabel = flavorMeta?.label ?? (item.flavor === 'custom' ? 'Como yo lo quiero' : item.flavor);

    let itemText = `*${index + 1}.* ${item.quantity}× ${sizeMeta?.label} ${flavorLabel}\n`;
    itemText += `   Acidez: ${catalog.acidez[item.acidezIndex]}\n`;
    itemText += `   Textura: ${catalog.textura[item.texturaIndex]}\n`;
    itemText += `   Grasas: ${catalog.grasas[item.grasasIndex]}\n`;
    
    if (item.toppings.length > 0) {
      const toppingsText = item.toppings
        .map((id) => catalog.toppings.find((t) => t.id === id)?.label)
        .filter(Boolean)
        .join(", ");
      itemText += `   Toppings: ${toppingsText}\n`;
    }
    
    return itemText;
  }).join("\n");
  
  const footer = `\nFecha: ${new Date().toLocaleDateString('es-UY')}\n⏰ Hora: ${new Date().toLocaleTimeString('es-UY', { hour: '2-digit', minute: '2-digit' })}\n\nMuchas gracias!`;
  
  return header + itemsText + footer;
};
